// Copyright aptihealth, inc. 2019 All Rights Reserved

import React from "react";

const HeadingPri = (props) => {
    return <h6 className="Schedule__TimeSlot-heading fs-14 fw-bold mt-4 mb-3">{props.text}</h6>;
};

export default HeadingPri;
